import { render, staticRenderFns } from "./ProfileUsers.vue?vue&type=template&id=6c25e911"
import script from "./ProfileUsers.vue?vue&type=script&lang=js"
export * from "./ProfileUsers.vue?vue&type=script&lang=js"
import style0 from "./ProfileUsers.vue?vue&type=style&index=0&id=6c25e911&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports